module.exports = __webpack_public_path__ + "static/media/klos-blank-classic.f01a1135.png";